export const INTERVIEW_SELECTION_STEP = 1;
export const INTERVIEWER_SELECTION_STEP = 2;
